import { Component, OnInit, EventEmitter, Input, PLATFORM_ID, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// parent component
import { ModalBaseComponent } from '../modal-base/modal-base.component';
// models
import { AppState } from '../../../../booking/models/app-state.interface';
// ngrx store
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

// services
import { FlightDetailsService } from '../../../../shared/services/flight-details.service';
import { ErrorHandler } from '../../../services/error-handler.service';

@Component({
  selector: 'app-modal-flight-direction',
  templateUrl: './modal-flight-direction.component.html',
  styleUrls: ['./modal-flight-direction.component.scss']
})
export class ModalFlightDirectionComponent extends ModalBaseComponent implements OnInit {

  @Input()
  modalData;

  public flightData;

  constructor(
    public appStore: Store<AppState>,
    public errorService: ErrorHandler,
    public router: Router,
    private _flightDetailsService: FlightDetailsService,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    super(appStore, errorService, router, platformId);
  }

  ngOnInit() {
    this.flightData = this.getState(this.appStore).flightFinderReducer;
  }

  goToFlightSearch(event) {
    this.errorService.modalItem$.next('remove');
    this.router.navigate(['flight-finder/search'], {queryParams: {'start-booking': true}});
  }

  close(event) {
    this.errorService.modalItem$.next('remove');
    this._flightDetailsService.cancelFlightRequest();
    this.appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
  }

  continue(event: Event) {
    event.preventDefault();

    let newDirection = 1;

    if (this.flightData.flightNumberSearchRequest.flightDirection === 1) {
      newDirection = 2;
    }

    this.appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_RESULTS', payload: [] });

    this._flightDetailsService.getFlightStatsData(null, {
      firstLeg: {
        flightNumber: this.flightData.flightNumberSearchRequest.flightNumber,
        flightDirection: newDirection,
        departureDate: this.flightData.flightNumberSearchRequest.departureDate,
        isPrimary: true
      }
    }, false, true);

    this.errorService.modalItem$.next('remove');

  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

}
